import { eventLocalDay } from './event-time';
import type React from 'react';

export const WEEKDAYS = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'] as const;

export const MONTHS = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
];

export const STATUS_LABELS: Record<string, string> = {
  SCHEDULED: 'Agendado',
  IN_PREPARATION: 'Em preparação',
  HAPPENING: 'Acontecendo',
  COMPLETED: 'Concluído',
  CANCELLED: 'Cancelado',
  POSTPONED: 'Adiado',
  ARCHIVED: 'Arquivado',
};

export const STATUS_VARIANTS: Record<string, string> = {
  SCHEDULED: 'info',
  IN_PREPARATION: 'warning',
  HAPPENING: 'success',
  COMPLETED: 'success',
  CANCELLED: 'danger',
  POSTPONED: 'warning',
  ARCHIVED: 'default',
};

export const TYPE_LABELS: Record<string, string> = {
  PUBLIC_FESTIVAL: 'Festividade pública',
  INTERNAL_OBLIGATION: 'Obrigação interna',
  MEETING: 'Reunião',
  MUTIRAO: 'Mutirão',
  CLEANING: 'Limpeza',
  MAINTENANCE: 'Manutenção',
  PURCHASE: 'Compra',
  ATTENDANCE: 'Atendimento',
  HOUSE_ANNIVERSARY: 'Aniversário da casa',
  DOCUMENT_DEADLINE: 'Prazo de documento',
  OTHER: 'Outro',
};

export const TYPE_COLORS: Record<string, string> = {
  PUBLIC_FESTIVAL: 'var(--danger-soft)',
  INTERNAL_OBLIGATION: 'var(--warning-soft)',
  MEETING: 'var(--success-soft)',
  MUTIRAO: 'var(--info-soft)',
  CLEANING: 'var(--info-soft)',
  MAINTENANCE: 'var(--soft)',
  PURCHASE: 'var(--success-soft)',
  ATTENDANCE: 'var(--soft)',
  HOUSE_ANNIVERSARY: 'var(--danger-soft)',
  DOCUMENT_DEADLINE: 'var(--soft)',
  OTHER: 'var(--soft)',
};

export const VISIBILITY_LABELS: Record<string, string> = {
  PUBLIC: 'Público',
  INTERNAL: 'Interno',
  RESTRICTED: 'Restrito',
};

export const Dt = ({ children }: { children: React.ReactNode }) => (
  <dt style={{ color: 'var(--ink)', fontWeight: 600, fontSize: '0.8rem', margin: 0 }}>
    {children}
  </dt>
);
export const Dd = ({ children }: { children: React.ReactNode }) => (
  <dd style={{ margin: 0, fontSize: '0.85rem', color: 'var(--ink)' }}>{children}</dd>
);

export const dlGrid: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: '90px 1fr',
  gap: '0.4rem 0.75rem',
};

export const inputCss: React.CSSProperties = {
  width: '100%',
  padding: '0.5rem 0.6rem',
  border: '1px solid var(--line)',
  borderRadius: 10,
  fontSize: '0.85rem',
  boxSizing: 'border-box',
  outline: 'none',
};

export const primaryBtn: React.CSSProperties = {
  background: 'var(--green)',
  color: '#fff',
  border: 'none',
  borderRadius: 999,
  padding: '0.45rem 1rem',
  fontSize: '0.8rem',
  fontWeight: 600,
  cursor: 'pointer',
};

export const secondaryBtn: React.CSSProperties = {
  background: '#fff',
  color: 'var(--muted)',
  border: '1px solid var(--line)',
  borderRadius: 999,
  padding: '0.45rem 1rem',
  fontSize: '0.8rem',
  cursor: 'pointer',
};

export const navBtn: React.CSSProperties = {
  background: '#fff',
  color: 'var(--muted)',
  border: '1px solid var(--line)',
  borderRadius: 999,
  padding: '0.3rem 0.75rem',
  fontSize: '0.75rem',
  cursor: 'pointer',
};

export const modalOverlay: React.CSSProperties = {
  position: 'fixed',
  inset: 0,
  background: 'var(--overlay)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 100,
};

export const modalStyle: React.CSSProperties = {
  background: '#fff',
  borderRadius: 14,
  padding: '1.5rem',
  minWidth: 380,
  maxWidth: 460,
};

export function formatDate(d: unknown): string {
  return eventLocalDay(d);
}

export function formatTime(value: unknown): string {
  if (typeof value !== 'string' && !(value instanceof Date)) return '';
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? ''
    : date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
}
